<template>
  <div class="suffix-icon margin-right-xs">
        <img class="suffix-icon-image" @error="handleError" v-if="!hasError"
            :src="thumbUrl"></img>
    </div>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      value: null
    },
    suffix: {
      type: String,
      value: ''
    },
  },
  data() {
    return {
      hasError: false,
      thumbUrl: '',
    }
  },
  methods: {
    handleError(e) {
      //console.error(e)
      this.hasError = true;
    },
    init(){
      this.thumbUrl = `https://assets.pfotoo.com/images/input/suffix-icon/${this.suffix}.svg`;
      //console.error('this.file', this.file);
      let crop='imageMogr2/auto-orient/thumbnail/90x/gravity/NorthWest/crop/90x90'
      if(this.file.mimeType.indexOf('image') !== -1){
        this.thumbUrl = this.file.url+'?'+crop;
      }else if(this.file.mimeType.indexOf('video') !== -1){
        this.thumbUrl = this.file.url+'?vframe/jpg/offset/1|'+crop;
      }

    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style>
.suffix-icon {
    width: 30px;
    height: 30px;
    background-image: url('https://assets.pfotoo.com/images/input/suffix-icon/def.svg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}

.suffix-icon-image {
    width: 30px;
    height: 30px;
    background-color: #fefefe;
}
</style>



// WEBPACK FOOTER //
// src/components/card/suffix-icon.vue